import logo from '../assets/logo.svg';
import bmftr_2 from '../assets/bmftr_2.png';

const Header: React.FC = props => {
    return (
      <header className="header">
        <div className="header-container">
            <div className="logo-container">
                <img className="header-logo" src={logo} alt="Logo von Medtec Online"></img>
            </div>
            <div className='bmbf-container'>
                  <div className='bmbf-logo-container'>
                    <img className='bmbf-logo' src={bmftr_2} alt="Logo des Bundesministerium für Forschung, Technologie und Raumfahrt"></img>
                </div>
            </div>
        </div>
      </header>
    );
};

export default Header;